import {
  AlertIcon,
  ErrorMessage,
  ErrorMessageContainer,
} from '../styles/common.styled';

interface ErrorsMessageContainerProps {
  errorMessage: string;
}

export const ErrorsMessageContainer = ({
  errorMessage,
}: ErrorsMessageContainerProps) => {
  return (
    <ErrorMessageContainer>
      <AlertIcon />
      <ErrorMessage>{errorMessage}</ErrorMessage>
    </ErrorMessageContainer>
  );
};
